<div class="qc-checklist-dialog" [class.qc-checklist-dialog--collapsed]="isCollapsed">
    <div class="qc-checklist-dialog__content">
        <app-qc-checklist
            [items]="checklistItems"
            [showHeader]="false"
            (itemsChange)="onItemsChange($event)"
            (allConfirmedChange)="onAllConfirmedChange($event)"
        ></app-qc-checklist>
    </div>

    <div class="qc-checklist-dialog__footer">
        <div class="qc-checklist-dialog__footer-left">
            <p-checkbox
                [ngModel]="allConfirmed"
                [binary]="true"
                (onChange)="onToggleAll($event.checked)"
                label="全部确认"
            ></p-checkbox>
        </div>
        <div class="qc-checklist-dialog__footer-right">
            <p-button
                label="质检拒绝"
                (onClick)="onRejectClick()"
                [disabled]="isRejectButtonDisabled"
                [loading]="isRejecting"
                styleClass="p-button-outlined p-button-sm p-button-danger"
                [outlined]="true"
            ></p-button>
            <p-button
                label="质检通过"
                (onClick)="onAcceptClick($event)"
                [disabled]="isAcceptButtonDisabled"
                [loading]="isAccepting"
                styleClass="p-button-outlined p-button-sm p-button-success"
                [outlined]="true"
            ></p-button>
        </div>
    </div>
</div>

<!-- Confirm popup for accept without revision -->
<p-confirmPopup key="confirm-accept-qc"></p-confirmPopup>

<!-- Toggle button template for header injection -->
<ng-template #toggleButtonTemplate>
    <p-button
        [icon]="isCollapsed ? 'pi pi-plus' : 'pi pi-minus'"
        [text]="true"
        [rounded]="true"
        (onClick)="onToggleCollapse()"
        styleClass="p-button-text p-button-secondary p-button-xs"
    ></p-button>
</ng-template>
